import React from 'react';
import CaseStudys from '../index';
import styles from './styles.module.scss';
import Hostecbanner from '../../../assets/casestudy/hostecbanner.webp';
import hostec1stimg from '../../../assets/casestudy/hostec1stimg.webp';
import hostec2ndimg from '../../../assets/casestudy/hostec2ndimg.webp';

import Mongodbicon from '../../../assets/img/mongodbicon.svg';
import Nodeicon from '../../../assets/img/nodeicon.svg';
import Reacticon from '../../../assets/img/reacticon.svg';
import Expressicon from '../../../assets/img/expressicon.svg';
import scentabook1stimg from '../../../assets/casestudy/scentabook1stimg.webp';
import KumarPhotography from '../../../assets/casestudy/KumarPhotoGraphy.webp';
import hostec3rdimg from '../../../assets/casestudy/hostec3rdimg.webp';
const AssetGlance = () => {
   const caseStudiesB = [
   
     {
      image: KumarPhotography,
      title: 'Kumar Photography',
      category: 'Website Design',
      link: 'https://kumarsphoto.com/',
    },
     {
        image: scentabook1stimg,
        title: 'Scentabook',
        category: 'Website Design',
        link: 'https://scentabook.com/',
      },
  ];
  const servicesB = [
  { label: 'UI & UX Design', link: 'https://metasoft.ae/services' },
  { label: 'Web Development', link: 'https://metasoft.ae/services' },
  { label: 'Performance Optimization', link: 'https://metasoft.ae/services'},
  { label: 'SEO', link: 'https://metasoftdm.com/marketing-solutions/seo/'},
];
  return (
    <CaseStudys
      title="Hostec"
       caseStudies={caseStudiesB} 
      subtitle="Elevating Hospitality Solutions"
      header='Elevating Hospitality Solutions'
      websiteUrl='https://hostec.com/'
      pagelink='/hostec'
      industry="Hospitality Staffing & Workforce Solutions"
    services={servicesB}
      description={
        <>
          <span>Hostec</span> Hostec is a leading hospitality staffing and talent solutions platform designed to connect premium hospitality businesses with skilled professionals across the UAE. Focused on streamlining recruitment and enhancing workforce efficiency in the hospitality sector, Hostec offers tailored staffing services, training programs, and a smart matching system that meets the dynamic needs of the industry. The platform is built to support hotels, restaurants, and event venues with a reliable, scalable, and professional approach to sourcing top-tier talent in a fast-paced market.
        </>
      }
      objective={{
        heading:'Building a Website That Showcases Hostec’s Services Clearly',
        content: (
          <>
            <p className={styles.projectText}>
          The objective of the Hostec website project was to develop a dynamic and user-centric platform that streamlines the recruitment and staffing process for the hospitality industry in the UAE. The goal was to connect top-tier hospitality talent with businesses in need of reliable staffing solutions, while simplifying job matching, onboarding, and workforce management. The project aimed to create a scalable and intuitive solution that reduces hiring friction, enhances candidate visibility, and supports real-time communication between employers and job seekers. By combining efficient design with powerful backend functionality, the platform was built to elevate recruitment standards and address the fast-paced, service-driven demands of the hospitality sector.
            </p>

           
          </>
        ),
      }}
      process={{
        heading: "How We Built a Clear and Professional Website for Hostec",
        content: (
          <>
            <p className={styles.projectText}>
        The development of the Hostec website followed a structured and collaborative approach, starting with a thorough analysis of the brand’s goals, target audience, and industry requirements. Based on these insights, we crafted a clean and intuitive website architecture that prioritizes easy navigation and clear presentation of services. The design phase emphasized a professional, welcoming aesthetic aligned with the hospitality sector, using engaging visuals and accessible content to appeal to both employers and job seekers. Development focused on building a responsive, fast-loading, and SEO-optimized site to ensure smooth performance across all devices. Regular feedback sessions and usability testing were conducted throughout the process to refine user experience and functionality. The project concluded with a seamless launch and ongoing support to help Hostec establish a strong digital footprint.
            </p>

         

           
          </>
        ),
      }}
      impact={{
        heading: 'How the Website Helped Hostec Reach More Clients',
        content: (
          <>
            <p className={styles.projectText}>
           The launch of the Hostec website significantly enhanced the brand’s digital presence, making it easier for hospitality businesses and job seekers to connect and engage online. The website’s clean design and user-friendly navigation improved accessibility and encouraged more efficient exploration of services and job opportunities. By offering seamless access to staffing solutions and valuable resources, the website increased user engagement and strengthened Hostec’s position as a trusted leader in hospitality recruitment across the UAE. Overall, the platform established a strong digital foundation to support business growth and foster ongoing community connections.
            </p>
           
           
          </>
        ),
      }}
       conclusion={{
        heading: 'Wrapping Up the Project',
        content: (
          <>
            <p className={styles.projectText}>
       In conclusion, the Hostec website successfully translated the brand’s commitment to hospitality staffing excellence into a polished and user-friendly digital platform. By combining clear design with intuitive functionality, the website now serves as a vital gateway for connecting talent with opportunity in the hospitality industry. This project not only strengthened Hostec’s online presence but also laid a solid foundation for continued growth, improved customer engagement, and enhanced service delivery in the competitive UAE hospitality market.
            </p>
           
          </>
        ),
      }}
      heroImage={Hostecbanner} // Add the hero image
      projectImage={hostec1stimg}
       projectImage2={hostec2ndimg}
           projectImage3={hostec3rdimg}
       // Add the project image
      technologies={[
           { name: 'MongoDB', icon: Mongodbicon },
        { name: 'Node.js', icon: Nodeicon },
        { name: 'React', icon: Reacticon },
        { name: 'Express.js', icon: Expressicon },
      ]} // Add the technologies used
      timescale="20 weeks" // Add the timescale
      launchDate="February 2025" // Add the launch date
    />
  );
};

export default AssetGlance;